export const POSTHOG_EVENTS = {
    CHECKIN_CREATED: 'checkin-created',
    BUTTON_CLICKED: 'button_clicked',
    FILE_DOWNLOADED: 'file_downloaded',
    REPORT_DOWNLOADED: 'report_downloaded',
    VIDEO_ACTIONED: 'video_actioned',
    LOGIN: 'login',
    REPORT_INTERACTION: 'report_interaction',
    AI_REPORT_SUMMARY_BUTTON: 'ai_report_summary_button',
    LMS_COURSE_ACTIONED: 'lms_course_actioned',
    TERM_SEARCHED: 'term_searched',
    // Journey milestones
    LESSON_ASSIGNED: 'lesson_assigned',
    REPORT_VIEWED: 'report_viewed',
    REPORT_REVIEW_OPENED: 'report_review_opened',
    EXEC_DASHBOARD_VIEWED: 'exec_dashboard_viewed',
    CLASS_DASHBOARD_VIEWED: 'class_dashboard_viewed',
    // Survey lifecycle
    SURVEY_LIBRARY_VIEWED: 'survey_library_viewed',
    SURVEY_ASSIGNED: 'survey_assigned',
    SURVEY_ATTEMPTED: 'survey_attempted',
    SURVEY_REPORT_VIEWED: 'survey_report_viewed',
};
